export default __webpack_public_path__ + "static/media/cert-student-consumer-sc.6df2d00b.jpg";